import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { User } from '../_models/user';
import { CustomerService } from '../_services/customer.service';

@Component({
    selector: 'app-ordersend',
    templateUrl: './ordersend.component.html',
    styleUrls: ['./ordersend.component.css'],
    standalone: false
})
export class OrdersendComponent implements OnInit {
  user : User;
  constructor(public customerService: CustomerService) { }

  ngOnInit(): void {
    this.customerService.currentUser$.pipe(take(1)).subscribe(user => this.user = user);
  }

}
